import React, { useRef, useState, useEffect, useMemo } from "react";
import AddRemainderModal from "./add-remainder-modal";
import Dropdown from "../../page/dashboard/dropdown-status";
import SearchForm from "../search-form";
import {
  setSearch,
  setLockToDoFilter,
  setSelectedFilter,
  setSelectedUserFilter,
  setSelectedToDoFilter,
  setGroupedByFilter,
} from "../../redux/actions/overview";
import { useDispatch, useSelector } from "react-redux";
import { sanitizeInput } from "../../utils";
import Select, { components } from "react-select";
import "../../css/theme.css";
import { Super_Admin, Admin } from "../../constant/AuthenticationConstant";

// Redux
import { getDepartment } from "../../redux/actions/department";
import { getCollaboratorOrCustomer } from "../../redux/actions/collaboratorOrCustomer";
import { getUsersByDepartmentId } from "../../redux/actions/todo";
import { getAllToDO } from "../../redux/actions/todo";

const { MenuList } = components;

const DashboardActions = () => {
  const trigger = useRef(null);
  const dropdown = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [filterOptions, setfilterOptions] = useState([]);
  const [userFilterOptions, setuserFilterOptions] = useState([]);
  const [todoFilterOptions, setTodoFilterOptions] = useState([]);
  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false);

  const dispatch = useDispatch();
  const {
    lockToDoFilter,
    selected,
    searchText,
    userTypeFilter,
    userFilter,
    todoFilter,
    groupedByFilter,
  } = useSelector((state) => state.overview);
  const user = useSelector((state) => state.auth);

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  const MoreSelectedBadge = ({ items }) => {
    const style = {
      marginLeft: "auto",
      fontFamily: "inter",
      fontSize: "14px",
      padding: "3px",
      fontWeight: 600,
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+ ${length}`;

    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 1;
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);

    return index < maxToShow ? (
      <components.MultiValue {...props} />
    ) : index === maxToShow ? (
      <MoreSelectedBadge items={overflow} />
    ) : null;
  };

  const getTeamsList = () => {
    dispatch(
      getDepartment((res) => {
        if (res.status) {
          const teamsOption = res.data.data.map((item) => {
            return {
              label: item.name,
              value: item.id,
              type: "teams",
            };
          });
          // teamsOption.unshift({
          //   label: "All Teams",
          //   value: "all teams",
          //   type: "teams",
          // });

          // Creating Options
          const options = [
            {
              label: "@Me",
              value: "me",
            },
            {
              label: "All",
              value: "all",
              type: "all",
            },
            {
              label: "Collaborator",
              value: "collaborator",
              type: "collaborators",
            },
            {
              label: "Customer",
              value: "customer",
              type: "customers",
            },
            {
              label: "Teams",
              options: teamsOption,
              type: "teams",
            },
          ];
          setfilterOptions(options);
        }
      })
    );
  };

  const getToDoList = () => {
    dispatch(
      getAllToDO("", "", "", "", "", "", (res) => {
        if (res.status) {
          const options = res.data.activities.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });

          setTodoFilterOptions(options);
        }
      })
    );
  };

  useEffect(() => {
    if (user.type === Super_Admin || user.type === Admin) {
      // API calling for teams list
      getTeamsList();
      // API calling for todo list
      getToDoList();
    }
  }, []);

  const getCollaboratorList = () => {
    dispatch(
      getCollaboratorOrCustomer("collaborator", (res) => {
        if (res.status) {
          const options = res.data.data.map((item) => {
            return {
              label: item.name,
              value: item.collaborator_id,
            };
          });
          setuserFilterOptions(options);
        }
      })
    );
  };

  const getCustomerList = () => {
    dispatch(
      getCollaboratorOrCustomer("customer", (res) => {
        if (res.status) {
          const options = res.data.data.map((item) => {
            return {
              label: item.name,
              value: item.collaborator_id,
            };
          });
          setuserFilterOptions(options);
        }
      })
    );
  };

  const getUserList = () => {
    dispatch(
      getUsersByDepartmentId(userTypeFilter.value, (res) => {
        if (res.status) {
          const options = res.data.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
          setuserFilterOptions(options);
        }
      })
    );
  };

  useEffect(() => {
    if (user.type === Super_Admin || user.type === Admin) {
      if (userTypeFilter?.type === "teams") {
        getUserList();
      } else if (userTypeFilter?.type === "collaborators") {
        getCollaboratorList();
      } else if (userTypeFilter?.type === "customers") {
        getCustomerList();
      }
    }
  }, [userTypeFilter]);

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
        <div className="space-x-4 flex items-center">
          <h4 className="text-xl leading-5 font-bold tracking-tight">
            To Do List
          </h4>
          <SearchForm
            placeholder="Search"
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              dispatch(setSearch(value));
            }}
            value={searchText}
          />
        </div>

        <div className="space-x-4 flex items-center justify-end">
          {/* <div className="my-2 sm:my-0 sm:grow-0 grow flex space-x-2 border border-red-500"> */}

          <button
            className={`btn ${
              lockToDoFilter
                ? "bg-[--bg-color-500] text-white"
                : `bg-white border-slate-200 hover:border-slate-300`
            } space-x-2 flex items-center rounded-lg`}
            onClick={() => {
              dispatch(setLockToDoFilter(!lockToDoFilter));
            }}
          >
            <span>Filter</span>
            <span className={`fa-solid fa-lock-open`}></span>
          </button>
          <Dropdown id={selected} htmlClass="w-52" />
          {(user.type === Super_Admin || user.type === Admin) && (
            <span
              onClick={() => setShowAdvanceFilter(!showAdvanceFilter)}
              className={`fa-solid fa-filters text-lg cursor-pointer ${
                showAdvanceFilter && "text-[--bg-color-500]"
              } `}
            ></span>
          )}

          {/* </div> */}

          {/* <AddRemainderModal
          id="reminder-modal"
          open={modalOpen}
          setModalOpen={setModalOpen}
        /> */}
        </div>
      </div>
      {showAdvanceFilter && (
        <div className="bg-[--bg-color-50] rounded h-[70px] flex items-center justify-between px-6">
          <div className="w-full grid grid-cols-3 gap-2">
            <Select
              className="unresetText text-sm"
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              value={userTypeFilter}
              isLoading={false}
              options={filterOptions}
              placeholder="Select Filter"
              onChange={(e) => {
                dispatch(setSelectedFilter(e));
                dispatch(setSelectedUserFilter())
              }}
            />
            <Select
              className="basic-multi-select unresetText text-sm"
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              options={userFilterOptions}
              placeholder="Select User"
              value={userFilter ? userFilter : ""}
              onChange={(e) => dispatch(setSelectedUserFilter(e))}
              isMulti
              isDisabled={
                userTypeFilter.value === "me" || userTypeFilter.value === "all"
              }
              components={{
                MultiValue,
              }}
            />
            <Select
              className="basic-multi-select unresetText text-sm"
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              options={todoFilterOptions}
              placeholder="Select To Do"
              value={todoFilter}
              onChange={(e) => dispatch(setSelectedToDoFilter(e))}
              isMulti
              components={{
                MultiValue,
              }}
            />
          </div>
          <div className="w-1/2 flex items-center justify-end">
            <button
              onClick={() => dispatch(setGroupedByFilter(!groupedByFilter))}
              className={`btn flex items-center space-x-2 ${
                groupedByFilter
                  ? "bg-[--bg-color-500] text-white"
                  : `bg-white border-slate-200 hover:border-slate-300`
              }`}
            >
              Grouped By
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardActions;
